export default function LoaderSponsorPackages() {
  return (
    <div className="mb-8 grid grid-cols-12 gap-2">
      <div
        data-aos={`fade-down`}
        className="col-span-6 h-96 animate-pulse bg-muted-300"
      ></div>
      <div
        data-aos={`fade-down`}
        className="col-span-6 h-96 animate-pulse bg-muted-300"
      ></div>
    </div>
  )
}
